import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _53ca7aa9 = () => interopDefault(import('../pages/a-good-company.vue' /* webpackChunkName: "pages/a-good-company" */))
const _0145682e = () => interopDefault(import('../pages/anker/index.vue' /* webpackChunkName: "pages/anker/index" */))
const _5b445187 = () => interopDefault(import('../pages/anker-bundle-aktion.vue' /* webpackChunkName: "pages/anker-bundle-aktion" */))
const _7abe9b70 = () => interopDefault(import('../pages/back-to-school.vue' /* webpackChunkName: "pages/back-to-school" */))
const _198c040c = () => interopDefault(import('../pages/bitte-kommen-sie-spaeter-wieder.vue' /* webpackChunkName: "pages/bitte-kommen-sie-spaeter-wieder" */))
const _2e9e0168 = () => interopDefault(import('../pages/google/index.vue' /* webpackChunkName: "pages/google/index" */))
const _b953bb8e = () => interopDefault(import('../pages/handyrechnung-aktion.vue' /* webpackChunkName: "pages/handyrechnung-aktion" */))
const _4b3b5377 = () => interopDefault(import('../pages/handyvergleich.vue' /* webpackChunkName: "pages/handyvergleich" */))
const _43865c04 = () => interopDefault(import('../pages/infos-zum-online-kauf.vue' /* webpackChunkName: "pages/infos-zum-online-kauf" */))
const _50b35180 = () => interopDefault(import('../pages/kontakt.vue' /* webpackChunkName: "pages/kontakt" */))
const _f78a201a = () => interopDefault(import('../pages/maintenance.vue' /* webpackChunkName: "pages/maintenance" */))
const _0ee43db6 = () => interopDefault(import('../pages/merkliste.vue' /* webpackChunkName: "pages/merkliste" */))
const _1a340a32 = () => interopDefault(import('../pages/panzerglass.vue' /* webpackChunkName: "pages/panzerglass" */))
const _55ad5384 = () => interopDefault(import('../pages/preisvorteile-sichern.vue' /* webpackChunkName: "pages/preisvorteile-sichern" */))
const _3b6cb05d = () => interopDefault(import('../pages/samsung/index.vue' /* webpackChunkName: "pages/samsung/index" */))
const _87093744 = () => interopDefault(import('../pages/samsung-cashback-aktion.vue' /* webpackChunkName: "pages/samsung-cashback-aktion" */))
const _c94521ba = () => interopDefault(import('../pages/smart-home-entdecken.vue' /* webpackChunkName: "pages/smart-home-entdecken" */))
const _b3f7bae4 = () => interopDefault(import('../pages/soundcore.vue' /* webpackChunkName: "pages/soundcore" */))
const _f9514f4a = () => interopDefault(import('../pages/stabiles-internet.vue' /* webpackChunkName: "pages/stabiles-internet" */))
const _d74a2c58 = () => interopDefault(import('../pages/themenwelten.vue' /* webpackChunkName: "pages/themenwelten" */))
const _625cedea = () => interopDefault(import('../pages/xiaomi.vue' /* webpackChunkName: "pages/xiaomi" */))
const _3c4ea98c = () => interopDefault(import('../pages/xiaomi-smartphones.vue' /* webpackChunkName: "pages/xiaomi-smartphones" */))
const _7d27f238 = () => interopDefault(import('../pages/xiaomi-zubehoer.vue' /* webpackChunkName: "pages/xiaomi-zubehoer" */))
const _8dd5f2f0 = () => interopDefault(import('../pages/zahlung-per-handyrechnung.vue' /* webpackChunkName: "pages/zahlung-per-handyrechnung" */))
const _6334e729 = () => interopDefault(import('../pages/anker/product-data.ts' /* webpackChunkName: "pages/anker/product-data" */))
const _6363a2de = () => interopDefault(import('../pages/google/product-data.js' /* webpackChunkName: "pages/google/product-data" */))
const _8e966c06 = () => interopDefault(import('../pages/hilfe/lieferstatus-und-retoure.vue' /* webpackChunkName: "pages/hilfe/lieferstatus-und-retoure" */))
const _0f071846 = () => interopDefault(import('../pages/magenta-black-days/page-data.js' /* webpackChunkName: "pages/magenta-black-days/page-data" */))
const _c9e9dfd0 = () => interopDefault(import('../pages/samsung/product-data.ts' /* webpackChunkName: "pages/samsung/product-data" */))
const _ce1b8306 = () => interopDefault(import('../pages/shop/bestaetigung.vue' /* webpackChunkName: "pages/shop/bestaetigung" */))
const _57548c6e = () => interopDefault(import('../pages/shop/brodos-zahlungsverifizierung.vue' /* webpackChunkName: "pages/shop/brodos-zahlungsverifizierung" */))
const _fec135ee = () => interopDefault(import('../pages/shop/fehler.vue' /* webpackChunkName: "pages/shop/fehler" */))
const _229d8bae = () => interopDefault(import('../pages/shop/kundenformular.vue' /* webpackChunkName: "pages/shop/kundenformular" */))
const _035217b1 = () => interopDefault(import('../pages/shop/kundenformular/index.vue' /* webpackChunkName: "pages/shop/kundenformular/index" */))
const _6b3e0905 = () => interopDefault(import('../pages/shop/kundenformular/persoenliche-daten.vue' /* webpackChunkName: "pages/shop/kundenformular/persoenliche-daten" */))
const _38dc7752 = () => interopDefault(import('../pages/shop/kundenformular/zahlungsart.vue' /* webpackChunkName: "pages/shop/kundenformular/zahlungsart" */))
const _52c9fc2a = () => interopDefault(import('../pages/shop/telekom-bestaetigung.vue' /* webpackChunkName: "pages/shop/telekom-bestaetigung" */))
const _4d630eb0 = () => interopDefault(import('../pages/shop/telekom-bezahlung-information.vue' /* webpackChunkName: "pages/shop/telekom-bezahlung-information" */))
const _5bb8de62 = () => interopDefault(import('../pages/shop/telekom-zahlungsverifizierung.vue' /* webpackChunkName: "pages/shop/telekom-zahlungsverifizierung" */))
const _d4f2a0c8 = () => interopDefault(import('../pages/shop/warenkorb.vue' /* webpackChunkName: "pages/shop/warenkorb" */))
const _58b0b3e0 = () => interopDefault(import('../pages/shop/zahlungsverifizierung.vue' /* webpackChunkName: "pages/shop/zahlungsverifizierung" */))
const _fbd49ed0 = () => interopDefault(import('../pages/shop/zusammenfassung.vue' /* webpackChunkName: "pages/shop/zusammenfassung" */))
const _5e59d25c = () => interopDefault(import('../pages/weitere-informationen/agb-brodos.vue' /* webpackChunkName: "pages/weitere-informationen/agb-brodos" */))
const _7f47784d = () => interopDefault(import('../pages/weitere-informationen/sitemap.vue' /* webpackChunkName: "pages/weitere-informationen/sitemap" */))
const _635d5bef = () => interopDefault(import('../pages/weitere-informationen/ueber-brodos.vue' /* webpackChunkName: "pages/weitere-informationen/ueber-brodos" */))
const _7ba8e6be = () => interopDefault(import('../pages/weitere-informationen/ueber-qivicon.vue' /* webpackChunkName: "pages/weitere-informationen/ueber-qivicon" */))
const _48a2b79c = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _3b13ab6e = () => interopDefault(import('../pages/magenta-moments-2024/_slug.vue' /* webpackChunkName: "pages/magenta-moments-2024/_slug" */))
const _f4e4b032 = () => interopDefault(import('../special-pages/product-details.vue' /* webpackChunkName: "" */))
const _ffccdd50 = () => interopDefault(import('../special-pages/shop-list.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/a-good-company",
    component: _53ca7aa9,
    name: "a-good-company"
  }, {
    path: "/anker",
    component: _0145682e,
    name: "anker"
  }, {
    path: "/anker-bundle-aktion",
    component: _5b445187,
    name: "anker-bundle-aktion"
  }, {
    path: "/back-to-school",
    component: _7abe9b70,
    name: "back-to-school"
  }, {
    path: "/bitte-kommen-sie-spaeter-wieder",
    component: _198c040c,
    name: "bitte-kommen-sie-spaeter-wieder"
  }, {
    path: "/google",
    component: _2e9e0168,
    name: "google"
  }, {
    path: "/handyrechnung-aktion",
    component: _b953bb8e,
    name: "handyrechnung-aktion"
  }, {
    path: "/handyvergleich",
    component: _4b3b5377,
    name: "handyvergleich"
  }, {
    path: "/infos-zum-online-kauf",
    component: _43865c04,
    name: "infos-zum-online-kauf"
  }, {
    path: "/kontakt",
    component: _50b35180,
    name: "kontakt"
  }, {
    path: "/maintenance",
    component: _f78a201a,
    name: "maintenance"
  }, {
    path: "/merkliste",
    component: _0ee43db6,
    name: "merkliste"
  }, {
    path: "/panzerglass",
    component: _1a340a32,
    name: "panzerglass"
  }, {
    path: "/preisvorteile-sichern",
    component: _55ad5384,
    name: "preisvorteile-sichern"
  }, {
    path: "/samsung",
    component: _3b6cb05d,
    name: "samsung"
  }, {
    path: "/samsung-cashback-aktion",
    component: _87093744,
    name: "samsung-cashback-aktion"
  }, {
    path: "/smart-home-entdecken",
    component: _c94521ba,
    name: "smart-home-entdecken"
  }, {
    path: "/soundcore",
    component: _b3f7bae4,
    name: "soundcore"
  }, {
    path: "/stabiles-internet",
    component: _f9514f4a,
    name: "stabiles-internet"
  }, {
    path: "/themenwelten",
    component: _d74a2c58,
    name: "themenwelten"
  }, {
    path: "/xiaomi",
    component: _625cedea,
    name: "xiaomi"
  }, {
    path: "/xiaomi-smartphones",
    component: _3c4ea98c,
    name: "xiaomi-smartphones"
  }, {
    path: "/xiaomi-zubehoer",
    component: _7d27f238,
    name: "xiaomi-zubehoer"
  }, {
    path: "/zahlung-per-handyrechnung",
    component: _8dd5f2f0,
    name: "zahlung-per-handyrechnung"
  }, {
    path: "/anker/product-data",
    component: _6334e729,
    name: "anker-product-data"
  }, {
    path: "/google/product-data",
    component: _6363a2de,
    name: "google-product-data"
  }, {
    path: "/hilfe/lieferstatus-und-retoure",
    component: _8e966c06,
    name: "hilfe-lieferstatus-und-retoure"
  }, {
    path: "/magenta-black-days/page-data",
    component: _0f071846,
    name: "magenta-black-days-page-data"
  }, {
    path: "/samsung/product-data",
    component: _c9e9dfd0,
    name: "samsung-product-data"
  }, {
    path: "/shop/bestaetigung",
    component: _ce1b8306,
    name: "shop-bestaetigung"
  }, {
    path: "/shop/brodos-zahlungsverifizierung",
    component: _57548c6e,
    name: "shop-brodos-zahlungsverifizierung"
  }, {
    path: "/shop/fehler",
    component: _fec135ee,
    name: "shop-fehler"
  }, {
    path: "/shop/kundenformular",
    component: _229d8bae,
    children: [{
      path: "",
      component: _035217b1,
      name: "shop-kundenformular"
    }, {
      path: "persoenliche-daten",
      component: _6b3e0905,
      name: "shop-kundenformular-persoenliche-daten"
    }, {
      path: "zahlungsart",
      component: _38dc7752,
      name: "shop-kundenformular-zahlungsart"
    }]
  }, {
    path: "/shop/telekom-bestaetigung",
    component: _52c9fc2a,
    name: "shop-telekom-bestaetigung"
  }, {
    path: "/shop/telekom-bezahlung-information",
    component: _4d630eb0,
    name: "shop-telekom-bezahlung-information"
  }, {
    path: "/shop/telekom-zahlungsverifizierung",
    component: _5bb8de62,
    name: "shop-telekom-zahlungsverifizierung"
  }, {
    path: "/shop/warenkorb",
    component: _d4f2a0c8,
    name: "shop-warenkorb"
  }, {
    path: "/shop/zahlungsverifizierung",
    component: _58b0b3e0,
    name: "shop-zahlungsverifizierung"
  }, {
    path: "/shop/zusammenfassung",
    component: _fbd49ed0,
    name: "shop-zusammenfassung"
  }, {
    path: "/weitere-informationen/agb-brodos",
    component: _5e59d25c,
    name: "weitere-informationen-agb-brodos"
  }, {
    path: "/weitere-informationen/sitemap",
    component: _7f47784d,
    name: "weitere-informationen-sitemap"
  }, {
    path: "/weitere-informationen/ueber-brodos",
    component: _635d5bef,
    name: "weitere-informationen-ueber-brodos"
  }, {
    path: "/weitere-informationen/ueber-qivicon",
    component: _7ba8e6be,
    name: "weitere-informationen-ueber-qivicon"
  }, {
    path: "/",
    component: _48a2b79c,
    name: "index"
  }, {
    path: "/magenta-moments-2024/:slug?",
    component: _3b13ab6e,
    name: "magenta-moments-2024-slug"
  }, {
    path: "/geraete/:slug?",
    component: _f4e4b032,
    name: "ProductDetails"
  }, {
    path: "/:config+",
    component: _ffccdd50,
    name: "ShopList"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
